import React from 'react';
import './index.css';

const BookingInfo = () => {
  return (
    <div className="booking-container">
      <h1 className="titleb">BEFORE YOU BOOK</h1>

      <section className="section">
        <h2>Payment Terms</h2>
        <div className="section-content">
          <div className="column">
            <h3>Modes of Payment</h3>
            <p>Credit card (3% surcharge applies), NEFT, Wire transfer</p>
          </div>
          <div className="column">
            <h3>Payment Deadlines</h3>
            <p>100% at the time of booking</p>
          </div>
        </div>
      </section>

      <hr className="divider" />

      <section className="section">
        <h2>Security Deposit</h2>
        <div className="section-content">
          <div className="column">
            <h3>Amount</h3>
            <p>One night charge of the villa</p>
          </div>
          <div className="column">
            <h3>Payment Collection Date</h3>
            <p>Time of booking</p>
          </div>
          <div className="column">
            <h3>Payment Return Date</h3>
            <p>Within 7 working days after stay account in India by NEFT</p>
          </div>
        </div>
        <div className="additional-info">
          <h3>How it is used</h3>
          <p>To protect the house against potential damages during the stay</p>
        </div>
        <hr className="divider" />
      </section>
    </div>
  );
};

export default BookingInfo;